import { IContractMutation } from 'services/contract/types';
import { IContractTemplateForm, TEMPLATE_TYPE } from 'services/templates/types';
import { separateContractTreeItems } from './contractFormItemSeparator';

export const contractFormToQuery = (
  form: IContractTemplateForm
): IContractMutation => {
  const mainItem = form.items[0];

  const title =
    mainItem.type === TEMPLATE_TYPE.contract ? mainItem.content : '';

  const details = form.details;

  const {
    subsections: customSections,
    digitalDistribution: digitalDistributionSection,
    physicalDistribution: physicalDistributionSection,
    merchDistribution: merchDistributionSection,
    channelDistribution: channelDistributionSection,
  } = separateContractTreeItems(form.items[0].children);

  if (!details) {
    throw new Error(
      'Failed to convert contract form to query due to details == null'
    );
  }

  return {
    customSections,
    digitalDistributionSection,
    physicalDistributionSection,
    merchDistributionSection,
    channelDistributionSection,
    title,
    endDate:
      details.withEndDate && details.endDate
        ? new Date(details.endDate).toISOString()
        : null,
    startDate: new Date(details.startDate).toISOString(),
    version: form.version
  };
};
